import en from './common/en/en.esm';
import fr from './common/fr/fr.esm';

const lang = {
    en: en,
    fr: fr,
}

export default lang;
